'use client';
/**
 * Created by nicolas.looschen@pikobytes.de on 17.02.2025.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { Box, Typography, useTheme } from '@mui/material';
import uniNeue from '../../configuration/theme/fonts/uniNeue';

export const PageTitle = ({ title }: { title: string }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 198,
                width: 1,
                justifyContent: 'center',
                display: 'flex',

                '.MuiTypography-h1': {
                    fontSize: '32px',
                    lineHeight: '34px',
                    color: 'common.white',
                    fontFamily: uniNeue.style.fontFamily,
                    fontWeight: 700,
                    letterSpacing: '2.56px',
                    textTransform: 'uppercase',

                    [theme.breakpoints.up('lg')]: {
                        fontSize: '64px',
                        lineHeight: '82px',
                    },
                },

                [theme.breakpoints.up('lg')]: {
                    top: 266,
                },
            }}
        >
            <Typography variant="h1">{title}</Typography>
        </Box>
    );
};

export default PageTitle;
